import { gunzipSync } from 'fflate';
import * as opfsStore from './opfs-store';

const KEY_PREFIX = 'p10gz';

function key(uid: string): string {
  return `${KEY_PREFIX}:${uid}`;
}

export async function stage(uid: string, blob: Blob): Promise<boolean> {
  if (!opfsStore.isHealthy()) return false;
  const buf = await blob.arrayBuffer();
  return opfsStore.writeBytes(key(uid), buf);
}

export async function loadCompressed(uid: string): Promise<Blob | null> {
  const buf = await opfsStore.readBytes(key(uid));
  if (!buf) return null;
  return new Blob([buf], { type: 'application/dicom' });
}

export async function loadUncompressed(uid: string): Promise<Uint8Array | null> {
  const buf = await opfsStore.readBytes(key(uid));
  if (!buf) return null;
  return gunzipSync(new Uint8Array(buf));
}

export async function evict(uid: string): Promise<void> {
  await opfsStore.deleteBytes(key(uid));
}
